import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FooterComponent.vue?vue&type=style&index=0&id=0af6e58e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af6e58e"]])

export default __exports__